export default {
  title: {
    en: 'Limited time private sale, happening now!',
  },
}
